import React, { useMemo } from "react";
import { EngSpecCommit } from "./EngSpec";
import { cn } from "@/lib/utils";
import { FileChange } from "./FileChange";
import { useCombinedFileChanges } from "../chat/useApplyChatBlock";
import { useIsChatLoading } from "@/store/zustand/aiContextStore";

export interface CommitProps {
  commit: EngSpecCommit;

  number?: number;

  // As of sep 8 - used in the ai chat context
  minimal?: boolean;
  readOnly?: boolean;
}

export const Commit = React.memo(
  ({ commit, minimal, readOnly }: CommitProps) => {
    const isChatLoading = useIsChatLoading();

    const combinedFileChanges = useCombinedFileChanges(
      commit?.changes,
      isChatLoading,
    );

    return (
      <div className="flex flex-col">
        <div
          className={cn("flex flex-col relative gap-1", minimal && "px-1 pt-1")}
        >
          <div className={"flex flex-row items-center gap-2.5 font-semibold"}>
            <div className="text-sm">{commit?.feature}</div>
          </div>
        </div>
        <div className="flex flex-col pt-3">
          {combinedFileChanges && Array.isArray(combinedFileChanges)
            ? combinedFileChanges.map((change, index) => (
                <FileChange
                  key={change.id || index}
                  file={{
                    id: change.id,
                    summary: change.summary,
                    termCommand: change.termCommand,
                    storyboardName: change.storyboardName,
                    path: change.path,
                    executedActivityId: change.executedActivityId,
                    hasChange: change.hasChange,
                  }}
                  index={index}
                  minimal={minimal}
                  readOnly={readOnly}
                />
              ))
            : null}
        </div>
      </div>
    );
  },
);
